import { DocumentsSearch } from 'components/documents-search';
import { PageHeader } from 'components/page-header';
import { SearchTabs } from 'components/search-tabs';
import AddDocumentModal from 'components/add-document-modal/add-document-modal';
import { DocumentStats } from './document-stats';

const Header = () => {
  return (
    <PageHeader
      breadcrumbs={[]}
      title={'Search'}
      actions={
        <div>
          <AddDocumentModal />
        </div>
      }
      aside={<DocumentStats />}
    >
      <SearchTabs />
    </PageHeader>
  );
};

const DocumentSearchPage = () => {
  return (
    <>
      <Header />
      <DocumentsSearch noGutter showTips />
    </>
  );
};

export { DocumentSearchPage };
